module.exports = __webpack_public_path__ + "media/components/assets/sujung_02-f0dc930f3109aa5d124236cf3aa1c5b4.png";